import React from 'react';
import __ from 'lodash';

class UploadHistory extends React.Component{
    render(){           
        return (
            this.props.uploadHis.map((val) =>
                <option key={val.idUploadHistory} value={val.idUploadHistory}>{val.keterangan}</option>
            )            
        )
    }
}

export default UploadHistory;